<script setup>
import { ref, toRaw, toRefs, watch } from 'vue';

import { DButton, DInputText } from '@disguise/cloud-ui';
import { Search } from '@disguise/cloud-ui/icons';

const props = defineProps({
  modelValue: {
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const { modelValue } = toRefs(props);
const internalModelValue = ref(structuredClone(toRaw(modelValue.value)));

watch(modelValue, () => {
  internalModelValue.value = structuredClone(toRaw(modelValue.value));
});

const handleModelValueUpdate = () => {
  emit('update:modelValue', structuredClone(toRaw(internalModelValue.value)));
};

const clearSearch = () => {
  internalModelValue.value = '';
  handleModelValueUpdate();
};
</script>

<template>
  <div class="flex w-full items-stretch">
    <span class="text-surface-400 flex w-10 items-center justify-center">
      <Search class="h-4 w-4" />
    </span>
    <DInputText
      placeholder="Find..."
      v-model="internalModelValue"
      @input="handleModelValueUpdate"
      :disabled="disabled"
      fluid />
    <span class="text-surface-400 flex w-10 items-center justify-center" v-if="internalModelValue.length > 0">
      <DButton icon="pi pi-times" @click="clearSearch" :disabled="disabled" text />
    </span>
  </div>
</template>
